// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { Collapseable } from "components/UI/Collapseable/Collapseable";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { useFieldArray } from "react-hook-form";

import { FormData } from "./formSchema";
import { ConditionsSection } from "./responseSection/ConditionsSection";
import { FurtherStepsSection } from "./responseSection/FurtherStepsSection";
import { HowToUseSection } from "./responseSection/HowToUseSection";
import { ResponseFields } from "./responseSection/ResponseFields";

interface ResponseConditionsFormProps {
    name: number; // index of the method in the methods array
}

export const ResponseConditionsForm: FC<ResponseConditionsFormProps> = ({ name: methodIndex }) => {
    const { t } = usePaldockTranslation("ui.connection-creator-editor.response-conditions");
    const generalFormUtils = useGeneralForm<FormData>();
    const { control } = generalFormUtils;

    // Path to responseHandlers array for this specific method index
    const responseHandlersPath = `methods.${methodIndex}.requestConfig.responseHandlers` as const;

    const { fields, append, remove } = useFieldArray({
        control,
        name: responseHandlersPath,
    });

    return (
        <Collapseable
            withAddItem
            title={t("sections.response_conditions.title")}
            handleAddItem={() =>
                append({
                    /* default values for a new responseHandler if needed */
                })
            }
            className="bg-neutral-200"
        >
            {fields.map((field, index) => {
                // const handlerPath = `${responseHandlersPath}.${index}` as const;

                return (
                    <Collapseable key={field.id} title={t("sections.response_condition_item.title")}>
                        {/* Passing down control, index, and methodIndex so these components can access their fields */}
                        <ResponseFields
                            name={index}
                            methodIndex={methodIndex}
                            handleRemoveResponse={() => remove(index)}
                        />
                        <ConditionsSection name={index} methodIndex={methodIndex} />
                        <HowToUseSection name={index} methodIndex={methodIndex} />
                        <FurtherStepsSection name={index} methodIndex={methodIndex} />
                    </Collapseable>
                );
            })}
        </Collapseable>
    );
};
